import { useTranslation } from 'react-i18next';
import { useApp } from '@/context/AppContext';
import styles from '@/styles/components/LanguageSwitcher.module.css';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const { dispatch } = useApp();

  const changeLanguage = (lng: 'en' | 'zh') => {
    i18n.changeLanguage(lng);
    dispatch({ type: 'SET_LANGUAGE', payload: lng });
    
    // Update URL parameter
    const url = new URL(window.location.href);
    url.searchParams.set('lang', lng);
    window.history.pushState({ lang: lng }, '', url.toString());
  };

  return (
    <div className={styles.languageSwitcher}>
      <a
        href="#"
        className={`${styles.languageLink} ${i18n.language === 'en' ? styles.active : ''}`}
        onClick={(e) => {
          e.preventDefault();
          changeLanguage('en');
        }}
      >
        EN
      </a>
      <a
        href="#"
        className={`${styles.languageLink} ${i18n.language === 'zh' ? styles.active : ''}`}
        onClick={(e) => {
          e.preventDefault();
          changeLanguage('zh');
        }}
      >
        中文
      </a>
    </div>
  );
}